import { render, staticRenderFns } from "./studentwork.vue?vue&type=template&id=1b78a32d&scoped=true"
import script from "./studentwork.vue?vue&type=script&lang=js"
export * from "./studentwork.vue?vue&type=script&lang=js"
import style0 from "./studentwork.vue?vue&type=style&index=0&id=1b78a32d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b78a32d",
  null
  
)

export default component.exports